import React, { useMemo } from 'react';
import { dateRangeToString } from './utils';
import { Badge } from '../Badge';
import { Reports } from '../../api/relevant';

interface DateBadgeProps {
	report: {
		settings: {
			dynamicDateRange?: string;
			start?: number | string | Date;
			end?: number | string | Date;
		};
	};
	skeleton?: boolean;
}

export function DateBadge({ report, skeleton = false }: DateBadgeProps) {
	const dateRange = useMemo(() => !skeleton && dateRangeToString(report?.settings), [report, skeleton]);
	return (skeleton || dateRange) && (
		<Badge
			color={dateRange?.relative ? 'blue' : 'grey'}
			className="self-start"
		>
			{dateRange?.text ?? <span className="invisible">Placeholder</span>}
		</Badge>
	);
}
